class TypeTool {
    static amountConversion(params: string | number): { integer: string; decimal: string } {
    // 1. 统一转为字符串并去除首尾空格
        const str = typeof params === "string" ? params.trim() : String(params);
        if (!str) {
            return { integer: "--", decimal: "" };
        }

        const hasQi = /[起]/.test(str);
        const cleanStr = str.replace(/¥/g, "").trim();
        const numPart = cleanStr.replace(/[起]/g, "").trim();
        const validNumRegex = /^-?\d+(\.\d+)?$/;
        if (!validNumRegex.test(numPart)) {
            return {
                integer: "--",
                decimal: ""
            };
        }

        // 4. 转换为数字并格式化为两位小数
        const num = Number(numPart);
        if (isNaN(num)) {
            return {
                integer: "--",
                decimal: ""
            };
        }
        const formattedNum = num.toFixed(2);

        // 5. 拆分整数和小数部分，并拼接“起”字（拼在整数末尾）
        const [integer, decimal] = formattedNum.split(".");
        const finalDecimal = hasQi ? `${decimal}起` : decimal;

        return {
            integer: integer, // 整数部分（含负号+起，如-100起/100起）
            decimal: `.${finalDecimal}` // 小数部分固定两位，如.00/.50
        };
    }


    static unifiedNavigateTo(url: string, query: Record<string, any> = {}, isBlank: boolean = false) {
        const queryString = new URLSearchParams(query).toString();
        const target = `${url}${queryString ? `?${queryString}` : ""}`;
        window.open(target, isBlank ? "_blank" : "_self");
    }

    static isNotEmtpy(value: any) {
        if (value === null || value === undefined) {
            return false;
        }
        if (value === "") {
            return false;
        }
        if (value === "{}") {
            return false;
        }

        if (value instanceof Array) {
            return value.length > 0;
        }
        if (value instanceof Map) {
            return value.size > 0;
        }
        if (value instanceof Object) {
            return Object.entries(value).length > 0;
        }
        return true;
    }

    static isEmtpy(value: any) {
        return !TypeTool.isNotEmtpy(value);
    }
}

export default TypeTool;